import { Coordinate } from "ol/coordinate";
import { createOrUpdateFromCoordinates, Extent } from "ol/extent";
import RouterUrl from "./RouterUrl";

import RouterUrlWithExtent from "./RouterUrlWithExtent";

export class Regions {
  routerBaseUrl = "https://router2.gpxplanner.app"
  routerUrlSources: RouterUrl[] = [
    {minLongitude: 116.5, maxLongitude: -98.5, url: `${this.routerBaseUrl}/routea/v1/mode/`, nearestUrl: `${this.routerBaseUrl}/nearesta/v1/mode/`},
    {minLongitude: -99.5, maxLongitude: -67.5, url: `${this.routerBaseUrl}/routeb/v1/mode/`, nearestUrl: `${this.routerBaseUrl}/nearestb/v1/mode/`},
    {minLongitude: -68.5, maxLongitude: 3.5, url: `${this.routerBaseUrl}/routec/v1/mode/`, nearestUrl: `${this.routerBaseUrl}/nearestc/v1/mode/`},
    {minLongitude: 2.5, maxLongitude: 24.5, url: `${this.routerBaseUrl}/routed/v1/mode/`, nearestUrl: `${this.routerBaseUrl}/nearestd/v1/mode/`},
    {minLongitude: 23.5, maxLongitude: 59.5, url: `${this.routerBaseUrl}/routee/v1/mode/`, nearestUrl: `${this.routerBaseUrl}/neareste/v1/mode/`},
    {minLongitude: 58.5, maxLongitude: 117.5, url: `${this.routerBaseUrl}/routef/v1/mode/`, nearestUrl: `${this.routerBaseUrl}/nearestf/v1/mode/`}
  ]
  routerUrls: RouterUrlWithExtent[] = this.routerUrlSources.map(r => new RouterUrlWithExtent(r))

  public async getUrl(coords: Coordinate[]): Promise<string> {
    const url = this.routerUrls.find(r => coords.every(c => r.containsCoordinate(c)))
    if(url === undefined) {
      console.error('Unable to find router url: ', coords)
      throw new Error('Unable to find route URL for coordinates')
    }

    return url.routerUrl.url
  }

  public async getNearestUrl(coord: Coordinate): Promise<string> {
    const url = this.routerUrls.find(r => r.containsCoordinate(coord))
    if(url === undefined) {
      console.error('Unable to find nearest url: ', coord)
      throw new Error('Unable to find nearest URL for coordinates')
    }

    return url.routerUrl.nearestUrl
  }

  getRouterExtent(routerUrl: RouterUrl): Extent {
    const coords: Coordinate[] = [
      [routerUrl.minLongitude, 0],
      [routerUrl.minLongitude, 90],
      [routerUrl.maxLongitude, 90],
      [routerUrl.maxLongitude, 0]
    ]
    return createOrUpdateFromCoordinates(coords)
  }
}

const regions = new Regions()
export default regions;
